export const OverdueIcon = () => (
  <svg
    aria-hidden="true"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 15.0013C10.2303 15.0013 10.4168 14.8148 10.4168 14.5846C10.4168 14.3545 10.2303 14.168 10.0002 14.168C9.77004 14.168 9.5835 14.3545 9.5835 14.5846C9.5835 14.8148 9.77004 15.0013 10.0002 15.0013Z"
      fill="#E01E4E"
    />
    <path
      d="M10.0002 19.1673C15.0628 19.1673 19.1668 15.0633 19.1668 10.0007C19.1668 4.93804 15.0628 0.833984 10.0002 0.833984C4.93755 0.833984 0.833496 4.93804 0.833496 10.0007C0.833496 15.0633 4.93755 19.1673 10.0002 19.1673Z"
      fill="#E01E4E"
      stroke="#E01E4E"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5V11.6667"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0002 15.0013C10.2303 15.0013 10.4168 14.8148 10.4168 14.5846C10.4168 14.3545 10.2303 14.168 10.0002 14.168C9.77004 14.168 9.5835 14.3545 9.5835 14.5846C9.5835 14.8148 9.77004 15.0013 10.0002 15.0013Z"
      fill="white"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
